import Vue from "vue";
import Vuex from "vuex";
import VueCookie from 'vue-cookie'
import apiInterface from "@/api/apiInterface";
import { post, get } from "@/api/axiosConfig";
import { getInfo, setUTC, getUser, getAreaForSymbol, setCookiesCategory } from "@/api/public";
import { getCookies, setCookies } from '@/utils/auth'
import enumInfo from "@/api/enum";
const $get = get;
const $post = post;
const $enumInfo = enumInfo.cardhobby
const $interface = apiInterface.Interface;
const domain = process.env.NODE_ENV == 'development' ? document.location.hostname : process.env.NODE_DOMAIN;;
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    loading: false,
    lang: VueCookie.get("CardLang") || "en", //多语言 - 当前语言类型
    appId: 'CarHobbyWeb',
    appSecret: 'CarHobbyWeb',
    token: '',
    storeToken: getCookies('CardHobbyStoreToken'),
    activityToken: getCookies('CardHobbyActivityToken'),
    userLog: '',
    shipCode: 'CardHobby23',
    areaSymbol: 'USD',
    isSaveTime: true,
    activityAreaCode: 'US',
    isSwitch: false,
    isQuestionnaire:true,
  },
  mutations: {
    setLoading(state, data) {
      state.loading = data;
    },
    SET_STOKEN: (state, token) => {
      state.storeToken = token
    },
    SET_ATOKEN: (state, token) => {
      state.activityToken = token
    }

  },
  actions: {
    setLoading: () => {
      commit('setLoading', data);
    },
    // 获取token
    getStoreToken({ dispatch, commit, state }, data) {
      return new Promise((resolve, reject) => {
        data = { appid: 'gfcomm', appkey: 'ghfw22TYHUR6U' };
        $post($interface.GetStoreToken, data).then(res => {
          const data = res.Data
          if (res.Result) {
            const expires = data.Expires
            commit('SET_STOKEN', data.Token)
            setCookies('CardHobbyStoreToken', data.Token, { domain: domain, expires: expires })
            resolve(res)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 检查token
    isStoreToken(state, value) {
      var isToken=true
      if (!state.state.storeToken||state.state.storeToken==null) {
        isToken=false
        //console.log(isToken,'isToken')
        //state.dispatch('getStoreToken')
      }
      return isToken
    },
    // 获取活动token
    getActivityToken({ dispatch, commit, state }, data) {
      return new Promise((resolve, reject) => {
        data = { appid: 'act', appkey: 'ghfw22TYHUR6U' };
        $post($interface.GetActivityToken, data).then(res => {
          const data = res.Data
          if (res.Result) {
            const expires = data.Expires
            commit('SET_ATOKEN', data.Token)
            setCookies('CardHobbyActivityToken', data.Token, { domain: domain, expires: expires })
            resolve(res)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // 检查活动token
    isActivityToken(state, value){
      if (!state.state.activityToken||state.state.activityToken==null) {
        //state.dispatch('getActivityToken')
        return false
      }
      return true
    },
    //
    setSaveTime(state, value) {
      let userInfo = getInfo();
      var time = new Date().getTime();
      time = setUTC(time, -8, 'cn').getTime()
      if (userInfo) {
        var saveDate = ''
        saveDate = window.localStorage.getItem('saveDate') ? window.localStorage.getItem('saveDate') : ''
        if (saveDate) {
          var data = JSON.parse(saveDate)
          if (data.u) {
            if (data.u == userInfo.MappingUserId) {
              var seven = 7 * 24 * 60 * 60 * 1000
              var oldTime = data.t
              if ((time - oldTime) > seven) {
                state.state.isSaveTime = false
              }
            } else {
              window.localStorage.setItem('saveDate', JSON.stringify({ u: userInfo.MappingUserId, t: time }))
            }
          } else {
            window.localStorage.setItem('saveDate', JSON.stringify({ u: userInfo.MappingUserId, t: time }))
          }
        } else {
          window.localStorage.setItem('saveDate', JSON.stringify({ u: userInfo.MappingUserId, t: time }))
        }
      }
    },
    // 获取买家对应货币符号
    getUserForSymbol(state, value) {
      //console.log(state,'state',value)
      let userInfo = getInfo();
      state.state.areaSymbol = getAreaForSymbol(userInfo, value)
    },
    getCookiesCategory(state) {
      let isCategory = VueCookie.get("cardCategory");
      if (isCategory != 0 && isCategory != null) {} else {
        setCookiesCategory()
      }
    },
    async getCookiesActivity(state, value) {
      //console.log(window.navigator.language,'window.navigator.language')
      let isActivityLanguages = getCookies('cardActivityLanguages');
      let isActivityUser = getCookies('cardActivityUser');
      let userInfo = await getInfo();
      let AreaData = $enumInfo.AreaData
      let isUser = { user: null, switch: '' }
      var isSwitch = false;
      let time = new Date(new Date().getTime() + 48 * 60 * 60 * 1000) //48小时

      if (userInfo) {
        state.state.activityAreaCode = userInfo.MemberSource
      } else {
        if (isActivityLanguages) {
          state.state.activityAreaCode = isActivityLanguages
        } else {
          var AreaCode = state.state.activityAreaCode
          var navlanguage = window.navigator.language
          AreaData.map(res => {
            if (res.browserLanguages == navlanguage) {
              state.state.activityAreaCode = AreaCode = res.areaCode
            }
            if (navlanguage == 'zh') {
              state.state.activityAreaCode = AreaCode = 'CN'
            }
            setCookies('cardActivityLanguages', AreaCode, { domain: domain, expires: time });
          })
        }
      }
      if (isActivityUser) {
        state.state.isSwitch = isSwitch = isActivityUser.switch
        var uid = userInfo ? userInfo.Id : null
        //console.log(isActivityUser.user, uid,isActivityUser.user != uid, 'isActivityUser.user')
        if ((isActivityUser.user != uid)||!isActivityUser.user) {
          isSwitch = await state.dispatch('getActivitySwitch', state.state.activityAreaCode)
          state.state.isSwitch = isSwitch
          isUser.user = userInfo ? userInfo.Id : null
          isUser.switch = isSwitch
          setCookies('cardActivityUser', isUser, { domain: domain, expires: time });
        }
      } else {

        //console.log(isActivityUser, uid, 'isActivityUser.user1')
        isSwitch = await state.dispatch('getActivitySwitch', state.state.activityAreaCode)
        state.state.isSwitch = isSwitch
        isUser.user = userInfo ? userInfo.Id : null
        isUser.switch = isSwitch
        setCookies('cardActivityUser', isUser, { domain: domain, expires: time });
      }
    },
    async getActivitySwitch(state, value) {
      let data = { areaCode: value }
      //console.log(value, 'value.user1')
      const activitySwitch = $get($interface.GetActivitySwitch, data).then(res => {
        //console.log(res, 'GetActivitySwitch.user1')
        if (res.Result) {
          if (res.Data) {
            if (res.Data) {
              if (res.Data.Show) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      }).catch(err => {
        return false
      })
      return activitySwitch
    },
    // 同步卖家端买家端用户信息
    checkUser(ctx) {
      //isToken()
      let userInfo = getInfo();
      if (userInfo) {
        if (userInfo.PointCount) {
          return true;
        } else {
          getUser(userInfo, 0)
          return true;
          //return getUser(userInfo,0)
        }
      }
    }
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    }
  },
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js